<template>
    <div>
        <h4 v-if="!authenticated">
            You are not logged in! Please <a @click="auth.login()">Log In</a> to continue.
        </h4>
        <v-container v-if="authenticated && hasPermission">
                <v-toolbar dense>
                    <v-text-field  hide-details  max="120" full-width single-line v-model="search"></v-text-field>
                    <!-- <v-btn flat>
                        Search
                    </v-btn> -->
                    <v-btn icon @click="getdata(search)">
                        <v-icon>search</v-icon>
                    </v-btn>
                </v-toolbar>
            <v-dialog v-model="isBusy" hide-overlay persistant width="300">
              <v-card
                color="primary"
                dark
              >
                <v-card-text>
                  Please stand by while consult Volturnus!
                  <v-progress-linear
                    indeterminate
                    color="white"
                    class="mb-0"
                  ></v-progress-linear>
                </v-card-text>
              </v-card>
            </v-dialog>
            <v-dialog
              v-model="isDialogOpen"
              fullscreen
              hide-overlay
              transition="dialog-bottom-transition"
              scrollable
            >
              <v-card tile>
                <v-toolbar card dark color="primary">
                  <v-btn icon dark @click="dialog = false">
                    <v-icon>close</v-icon>
                  </v-btn>
                  <v-toolbar-title>Alerts Details</v-toolbar-title>
                  <v-spacer></v-spacer>
                </v-toolbar>
                <v-card-text>
                  <v-expansion-panel v-if="authenticated && hasPermission">
                    <v-expansion-panel-content v-for="(alertIQ,i) of LastSevenDaysFilteredByIQ" :key="i">
                      <div slot="header">{{alertIQ.subject}}</div>
                      <v-card>
                        <v-card-text class="grey darken-2">
                          <pre>{{alertIQ.body}}</pre>
                        </v-card-text>
                      </v-card>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-card-text>
      
                <div style="flex: 1 1 auto;"></div>
              </v-card>
            </v-dialog>

            <v-list three-line>
                <v-subheader>Last 7 Days Data</v-subheader>
                <template v-for="(post, index) of posts">
                    <v-list-tile avatar ripple :key="index" @click="alertdetail(post._id)" >
                        <v-list-tile-content>
                            <v-list-tile-title>{{ post._id }}</v-list-tile-title>
                            <v-list-tile-sub-title>First Subject<pre>{{ post.subject }}</pre>
                                </v-list-tile-sub-title>
                        </v-list-tile-content>
                        <v-list-tile-action>
                            <v-list-tile-action-text>count:{{ post.count }}</v-list-tile-action-text>
                            <!-- <v-icon color="grey lighten-1">info</v-icon> -->
                        </v-list-tile-action>
                    </v-list-tile>
                    <v-divider v-if="index + 1 < posts.length" :key="`divider-${index}`"></v-divider>
                </template>
            </v-list>
        </v-container>
        <v-container v-if="authenticated && !hasPermission">
            <p>You do not have access to this area. Please contact Cody at D&S for access.</p>
        </v-container>
        <!-- <ul v-if="posts && posts.length">
            <li v-for="post of posts" :key="post._id">
            <p><strong>{{post.subject}}</strong></p>
            <p><pre>{{post.body}}</pre></p>
            </li>
        </ul> -->
    </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AlertsReport',
  props: ['auth', 'authenticated'],
  data() {
    return {
      msg: 'Alert Report',
      error: [],
      search: '',
      dialog: false
    };
  },
  computed: {
    posts: function() {
      return this.$store.getters.posts;
    },
    hasPermission() {
      return this.$store.getters.roles.indexOf("GlobalAdmin") > -1 || this.$store.getters.roles.indexOf("DSCarwash") > -1 ;
    },
    LastSevenDaysFilteredByIQ() { 
      return this.$store.getters.resentPostFilteredByIQ;
    },
    isBusy() {
      return this.$store.getters.isBusy;
    },
    isDialogOpen(){
      return !this.isBusy && this.dialog;
    }

  },
  methods: {
    alertdetail(index) { 
      console.log(index, this.search);
      this.$store.commit('setIsBusy', true);
      let _filter = { search: '', serial: '' };
      _filter.search = this.search;
      _filter.serial = index;
      this.$store.dispatch('loadLastSevenDaysFilteredByIQ', _filter);
      this.dialog = true;
    },
    getdata(filter) {
      //"Ultrasonic Parameter Mismatch"
      
      console.log(filter);
      let _filter = { search: '' };
      _filter.search = filter;
      console.log(_filter);
      this.$store.commit('setIsBusy', true);
      this.$store.dispatch('load_comments', _filter);
    }
  },
  created() {
    // axios
    //   .get(`http://jsonplaceholder.typicode.com/comments`)
    //   .then(response => {
    //     this.posts = response.data;
    //   })
    //   .catch(e => {
    //     this.error.push(e);
    //   });
  }
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/components/AlertsReport.vue